defineDs('DanskeSpil/Domain/PlayTogether/Scripts/Templates/Clubs/ClubCard', [
  'Shared/Framework/Mithril/Scripts/Core/Mithril',
  'Shared/Framework/Ensighten/Scripts/Ensighten',
  'DanskeSpil/Domain/PlayTogether/Scripts/Helpers/Utils',
  'DanskeSpil/Domain/PlayTogether/Scripts/Templates/Common/CtaButton',
  'DanskeSpil/Domain/PlayTogether/Scripts/Templates/Common/Ribbon',
  'DanskeSpil/Domain/PlayTogether/Scripts/Templates/Common/Avatar',
  'DanskeSpil/Domain/PlayTogether/Scripts/Templates/Clubs/PlayCountdown',
  'DanskeSpil/Domain/PlayTogether/Scripts/Templates/Common/Card/ClubCard',
],
function (m, Ensighten, Utils, CtaButton, Ribbon, Avatar, PlayCountdown, ClubCardTemplate) {
  var playersLimit = 4;

  var ClubCard = {
    controller: function ({ controller, club, asInvitation }) {
      Object.assign(this, controller);
      this.dictionary = this.rootDictionary.get.bind({ prefix: 'ViewMyClubs/ClubCard/' });
      this.clubDetails = club.fields;
      this.clubId = this.clubDetails.clubId();
      this.clubName = this.clubDetails.clubName();
      this.playersCount = this.clubDetails.clubPlayerCount();
      this.clubActivePlaysCount = this.clubDetails.activePlaysCount();
      const plays = asInvitation ? club.fields.activePlays() : this.clubDetails.myOffersAndActivePlays();

      this.playsIsParticipating = plays
        .filter((play) => play.mySummary.stakeAmount > 0)
        .map((play) => {
          let gameName = play.game.toLowerCase();
          if (gameName === 'lottosaturday') {
            gameName = 'lotto';
          }
          return {
            ...play,
            game: gameName,
          };
        });

      this.playsIsNotParticipating = plays
        .filter((play) => play.mySummary.stakeAmount === 0)
        .map((play) => {
          let gameName = play.game.toLowerCase();
          gameName = gameName === 'lottosaturday' ? 'lotto' : gameName;
          let playParams = `klubId=${this.clubId}`;
          if (play.subscriptionGroupGameId) {
            playParams += `&subscriptionGroupGameId=${play.subscriptionGroupGameId}`;
          } else {
            playParams += `&spilId=${play.groupPlayId}`;
          }
          return {
            ...play,
            game: gameName,
            buyInLink: `${this.navigationPaths.buyInPage}?${playParams}`
          };
        });


      this.playersListLabel = this.dictionary('PlayersListLabel' + (this.playersCount === 1 ? 'Single' : ''), { membersCount: this.playersCount });
      this.players = this.clubDetails.clubPlayers();

      this.showInviteButton = m.prop(false);

      if (!asInvitation) {
        this.showInviteButton(this.clubDetails.rules.allowAllInvite() || this.currentUser().playerId === this.clubDetails.chairman().playerId);
      }
    },
    view: function (controller, { asInvitation, action }) {

      var chairmanId = !asInvitation ? controller.clubDetails.chairman().playerId : null;
      var clubTheme = controller.clubDetails.theme;
      var clubColor = clubTheme.colorTheme();
      var clubBackground = clubTheme.background();
      var clubBadge = clubTheme.badge();
      var clubBadgeBackground = clubTheme.badgeBackground();
      var setThemeVars = function ($element) {
        if (clubColor && Utils.isValidHexCode(clubColor.code)) {
          Utils.setCssHslVariables({
            hexColor: clubColor.code,
            rootElement: $element
          });
        }

        if (clubBackground) {
          $element.style.setProperty('--club-theme-background-image-url', 'url(' + clubBackground.url + ')');
        }
      }.bind(this);

      const $header = [
        Ribbon({
          title: controller.clubName,
          badge: clubBadge,
          badgeBackground: clubBadgeBackground
        }),
        action.href ? m('a.play-together-club-card__header-link', { href: action.href }) : null
      ];

      const $content = [
        m('.play-together-club-card__content-section', [
          m('.play-together-club-card__content-section-header', [
            m('strong', controller.playersListLabel)
          ]),
          controller.players && controller.players.length ? m('.play-together-club-card__content-section-players', controller.players.map(function (player, index, playersList) {
            if (index === playersLimit) {
              return Avatar({
                value: '+' + (playersList.length - playersLimit)
              });
            }
            if (index > playersLimit) {
              return null;
            }
            return Avatar({
              isChairman: player.playerId === chairmanId,
              name: player.name
            });
          }),
          ) : null
        ]),
        m('.play-together-club-card__content-section', [
          controller.clubActivePlaysCount === 0 ? m('.play-together-club-card__content-section-header .play-together-club-card__content-section-header--noactive', [
            m('strong', controller.clubActivePlaysCount === 0 ? controller.dictionary('NoActivePlaysLabel') : '')
          ]) : null,
          controller.playsIsNotParticipating?.length > 0 ? [m('.play-together-club-card__content-section-plays--header', controller.dictionary('HeaderCanParticipate')), m('.play-together-club-card__content-section-plays', controller.playsIsNotParticipating.map(function (play) {
            const playJackpotSize = controller.settings?.jackpots[play.game];

            return m(`.play-together-club-card__play-line.play-together-club-card__play-line--${play.game} ${play?.subscriptionGroupGameId ? 'play-together-club-card__play-line--subscription' : ''} ${play.jackpot ? 'play-together-club-card__play-line--jackpot' : ''}`, [
              m('div', [
                m('.play-together-club-card__play-line-logo', [
                  play?.subscriptionGroupGameId ? m('svg.play-together-club-card__play-line-logo-icon--subscription', [
                    m('use', { href: Utils.mapGameTypeIcon('playtogethersubscription') })
                  ]) : null,
                  m('svg.play-together-club-card__play-line-logo-icon--main', [
                    m('use', { href: Utils.mapGameIcon(play.game) })
                  ]),
                  play.jackpot && play.game === 'eurojackpot' ? m('svg.play-together-club-card__play-line-logo-icon--jackpot', [
                    m('use', { href: Utils.mapGameTypeIcon('jackpot') })
                  ]) : null
                ]),
                m('.play-together-club-card__play-line-teaser', [
                  // if playJackpotSize is null, don't show the jackpot size and text
                  m('.play-together-club-card__play-line-pool', playJackpotSize ? m.trust(controller.dictionary('PoolSizeText', { poolSize: playJackpotSize })) : null),
                ]),
              ]),
              m('.play-together-club-card__play-line-details',
                CtaButton({
                  text: controller.dictionary('Participate'),
                  href: play.buyInLink,
                  options: ['primary', 'small']
                })
              )
            ]);
          }))] : null,
          controller.playsIsParticipating && controller.playsIsParticipating.length > 0 ? [m('.play-together-club-card__content-section-plays--header', controller.dictionary('HeaderIsParticipating')), m('.play-together-club-card__content-section-plays', controller.playsIsParticipating.map(function (play) {
            return m(`.play-together-club-card__play-line.play-together-club-card__play-line--${play.game} ${play?.subscriptionGroupGameId ? 'play-together-club-card__play-line--subscription' : ''} ${play?.jackpot ? 'play-together-club-card__play-line--jackpot' : ''} `, [
              m('div', [
                m('.play-together-club-card__play-line-logo', [
                  play?.subscriptionGroupGameId ? m('svg.play-together-club-card__play-line-logo-icon--subscription', [
                    m('use', { href: Utils.mapGameTypeIcon('playtogethersubscription') })
                  ]) : null,
                  m('svg.play-together-club-card__play-line-logo-icon--main', [
                    m('use', { href: Utils.mapGameIcon(play.game) })
                  ]),
                  play.jackpot && play.game === 'eurojackpot' ? m('svg.play-together-club-card__play-line-logo-icon--jackpot', [
                    m('use', { href: Utils.mapGameTypeIcon('jackpot') })
                  ]) : null
                ]),
                m('.play-together-club-card__play-line-teaser', [
                  m('.play-together-club-card__play-line-countdown-text', controller.dictionary('CountdownText')),
                  m('.play-together-club-card__play-line-countdown', [
                    PlayCountdown({
                      timestamp: play.nextDraw,
                      includeDays: true,
                    })
                  ])
                ])
              ]),
              m('.play-together-club-card__play-line-details',
                m('.play-together-club-card__play-line-details-icon', [
                  m('svg', [
                    m('use', { href: '/Components/DanskeSpil/Domain/PlayTogether/Graphics/SpriteSheets/PlayTogetherIcons.svg#checkmark2025' })
                  ])
                ])
              )
            ]);
          }))] : null
        ]),
        CtaButton({
          text: action.text,
          href: action.href,
          onClick: action.action,
          options: action.options || ['yellow', 'medium']
        })
      ];

      // Return:
      const clubCardTemplate = ClubCardTemplate({ $header, $content });
      clubCardTemplate.attrs.config = setThemeVars;

      return clubCardTemplate;
    }
  };

  // Public functions:
  return ClubCard;
});
